import { Radio, RadioGroup } from 'fronton-react';
import React, { ChangeEvent } from 'react';
import { DURATION_OF_USE } from 'common/constants';

type ReviewUsageTimeProps = {
  value: string | null;
  setTime: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const ReviewUsageTime: React.FC<ReviewUsageTimeProps> = ({ value, setTime }) => {
  return (
    <RadioGroup name="time_usage" value={value} onChange={setTime}>
      {Object.entries(DURATION_OF_USE).map(([key, label], index) => (
        <Radio key={key} label={label} value={key} data-ga-index={index + 1} />
      ))}
    </RadioGroup>
  );
};
